var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "转移汇报",
        visible: _vm.visible,
        width: "836px",
        "append-to-body": true,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "title-name" }, [_vm._v("转移汇报")]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.btnTransfer,
              expression: "btnTransfer",
            },
          ],
          staticClass: "el-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.reportList,
            "header-cell-style": {
              background: "#F5F5F5",
              color: "#2F3030",
              fontSize: "14px",
              fontWeight: "400",
            },
          },
        },
        [
          _vm.type === "workPhone"
            ? _c("el-table-column", {
                attrs: { prop: "phone", label: "工作手机号", width: "180" },
              })
            : _vm.type === "workWechat"
            ? _c("el-table-column", {
                attrs: { prop: "account", label: "工作微信号", width: "180" },
              })
            : _vm.type === "workQQ"
            ? _c("el-table-column", {
                attrs: { prop: "account", label: "工作QQ号", width: "180" },
              })
            : _vm.type === "workEmail"
            ? _c("el-table-column", {
                attrs: { prop: "account", label: "工作邮箱", width: "180" },
              })
            : _vm.type === "platformAccount"
            ? _c("el-table-column", {
                attrs: { prop: "account", label: "平台账号", width: "180" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              prop: "sourceOwnerUserName",
              label: "归属人",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "destOwnerUserName", label: "转移对象" },
          }),
          _c("el-table-column", {
            attrs: { prop: "result", label: "转移是否已发起" },
          }),
          _c("el-table-column", {
            attrs: { prop: "errorMessage", label: "失败原因" },
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("已知悉")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }